import React, { useState, useEffect } from "react";
import CompView from "./CompView";

const ScreenPart = ({ spec, editing, onChange }) => {
  let view = "";
  if (spec.get("view")) view = <CompView compId={spec.get("view")} />;
  let streams = "";
  if (spec.get("stateStream"))
    streams = <CompView compId={spec.get("stateStream")} />;
  return (
    <div className="ScreenPart">
      {streams}
      {view}
    </div>
  );
};
export default ScreenPart;



// WEBPACK FOOTER //
// ./src/components/ScreenPart.js